import React, { useEffect, useState } from 'react';
import './RedemptionsReport.less';
import {
  Col,
  Form,
  Row,
  Typography,
  VertButton,
  VertContainer,
  VertDatePicker,
  VertIcon, VertInput,
  VertModal,
  VertSelect,
} from '@vertem-core/vertice-ds';
import locale from 'antd/es/date-picker/locale/pt_BR';
import { LuFilter, LuFileSpreadsheet, LuDownload } from 'react-icons/lu';
import { useDispatch, useSelector } from 'react-redux';
import {
  LoadAllRedeems, LoadClcientsSolicitations, LoadWallet, cleanTableInfo, resetPageNumber,
} from 'redux/Reducers/ReportRedemption/ReportRedemptionSlice';
import dayjs from 'dayjs';
import {
  FILTER_TYPES, OPTIONS_REDEMPTIONS, datePickerPlaceholder, statusOptions,
} from './Constants';
import ReportTable from './components/ReportTable';
import OrderDetailsModal from './components/OrderDetailsModal';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import { useNavigate } from 'react-router';
import UnauthorizedSpot from 'pages/newSolicitation/components/UnauthorizedSpot/UnauthorizedSpot';

const RedemptionsReportPage = () => {
  const { isPMO, isManager, isLead, getRedemptionSpotGroups } =
    useParticipantSubSegment();
  const validGroup = getRedemptionSpotGroups();
  const [orderSelected, setOrderSelected] = React.useState(null);
  const [openedModal, setOpenedModal] = React.useState(false);
  const [error, setError] = useState(false);

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    isLoadingWallet, walletInfo, allParticipantsLoginsOfWallet,
    pageSize, currentPage,
  } = useSelector((state) => state.ReportRedemption);
  const participantId = useSelector((state) => state.oidc.user.profile['custom:participant_id']);

  const {
    dataSpot: spot,
  } = useSelector((state) => state.SpotAproveRedemption);

  const [filterTypeSelected, setFilterTypeSelected] = React.useState(
    FILTER_TYPES.SEE_ALL_REDEEMS.value,
  );

  const submitFilters = (submitPageSize) => {
    const data = form.getFieldsValue();

    const formattedGeneraldata = {
      initialDate: data['date-from']?.format('YYYY-MM-DD') ?? '',
      finalDate: data['date-to']?.format('YYYY-MM-DD') ?? '',
      pageNumber: filterTypeSelected
        === FILTER_TYPES.SEE_CLIENTS_SOLICITATIONS.value
        ? (currentPage - 1) : currentPage,
      pageSize: submitPageSize ?? pageSize,
    };

    const formattedDataAllRedeems = {
      ...formattedGeneraldata,
      participantLogins:
        (data['participant-filter']
          && data['participant-filter'].length
        )
          ? [data['participant-filter']]
          : allParticipantsLoginsOfWallet,
      parentOrderId: data['id-filter'] === '' ? undefined : data['id-filter'],
      statusId: data['status-filter'] === 0 ? undefined : data['status-filter'],
    };

    const formattedDataClientsSolicitations = {
      ...formattedGeneraldata,
      type: data['type-filter'] === 0 ? undefined : data['type-filter'],
      redemptionStatus: data['status-filter'] === 0 ? undefined : data['status-filter'],
      id: data['id-filter'] ?? '',
      participantLogin: data['participant-filter'] ?? '',
    };

    if (filterTypeSelected === FILTER_TYPES.SEE_ALL_REDEEMS.value) {
      dispatch(LoadAllRedeems(formattedDataAllRedeems));
    } else {
      dispatch(LoadClcientsSolicitations(formattedDataClientsSolicitations));
    }
  };

  const formInitialValues = {
    filterType: FILTER_TYPES.SEE_ALL_REDEEMS.value,
    'date-to': dayjs(),
    'date-from': dayjs().startOf('month'),
    remember: true,
  };

  useEffect(() => {
    dispatch(LoadWallet());
  }, []);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      allParticipantsLoginsOfWallet
        && allParticipantsLoginsOfWallet.length > 0
        && submitFilters();
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [currentPage, allParticipantsLoginsOfWallet]);

  const validateAccess = (redirect = false) => {
    let isValid = false;

    if (isPMO || isLead || isManager || spot.participantId == participantId) {
      isValid = true;
    }

    if (!isValid && redirect) {
      return navigate('/');
    } else {
      return isValid;
    }
  };

  useEffect(() => {
    if (spot !== null) {
      validateAccess(true);
      if (
        !isPMO &&
        !validGroup &&
        !isManager &&
        !isLead &&
        !(spot.participantId == participantId)
      ) {
        setError(true);
      }
      if (!isPMO && !isLead && spot.redemptionStatusId !== 4) {
        setError(true);
      }
    }
  }, [spot]);

  return error ? (
    <UnauthorizedSpot />
  ) : (
    <>
      <VertContainer>
        <div className="redemptions-report-page">
          <Typography.Title className="page-title margin-top-regular margin-bottom-extra-small">
            Solicitações e Resgates de Clientes
          </Typography.Title>
          <Typography.Text className="color-highlight">
            Visualize o histórico de solicitações e resgates
          </Typography.Text>

          <VertContainer className="margin-top-regular">
            <VertIcon component={LuFilter} color="highlight" />
            <Typography.Text className="txt-big color-highlight margin-left-extra-small">
              Filtros
            </Typography.Text>
          </VertContainer>
          <VertContainer className="margin-top-small">
            <Form
              form={form}
              scrollToFirstError
              name="basic"
              initialValues={formInitialValues}
              autoComplete="off"
            >
              <Row gutter={{
                lg: 16, md: 16, sm: 16, xs: 16,
              }}
              >
                <Col lg={12} md={24} sm={24} xs={24}>
                  <Form.Item
                    noStyle
                    name="filterType"
                    validateTrigger="onBlur"
                  >
                    <VertSelect
                      items={[
                        FILTER_TYPES.SEE_ALL_REDEEMS,
                        FILTER_TYPES.SEE_CLIENTS_SOLICITATIONS,
                      ]}
                      onChange={(e) => {
                        dispatch(cleanTableInfo());
                        dispatch(resetPageNumber());
                        setFilterTypeSelected(e);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col lg={6} md={12} sm={12} xs={24}>
                  <Form.Item
                    noStyle
                    name="date-from"
                    validateTrigger="onBlur"
                  >
                    <VertDatePicker
                      // prefix={isLoadingAddress && <VertIcon component={LoadingOutlined} />}
                      placeholder={
                        `Date De (${datePickerPlaceholder(filterTypeSelected)})`
                      }
                    />
                  </Form.Item>
                </Col>
                <Col lg={6} md={12} sm={12} xs={24}>
                  <Form.Item
                    noStyle
                    name="date-to"
                    validateTrigger="onBlur"
                  >
                    <VertDatePicker
                      locale={locale}
                      // prefix={isLoadingAddress && <VertIcon component={LoadingOutlined} />}
                      placeholder={
                        `Date Até (${datePickerPlaceholder(filterTypeSelected)})`
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="margin-top-small">
                <Col lg={16} md={16} sm={24} xs={24}>
                  <Form.Item
                    noStyle
                    name="participant-filter"
                    validateTrigger="onBlur"
                  >
                    <VertSelect
                      showSearch
                      allowClear
                      filterOption={(input, option) => (option?.label.replace(/[.-/]/g, '').toUpperCase() ?? '').includes(input.toUpperCase())}
                      items={walletInfo}
                      loading={isLoadingWallet}
                      placeholder={`${isLoadingWallet ? 'Carregando participantes...' : 'Digite o documento ou o nome do participante'}`}
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <Form.Item
                    noStyle
                    name="id-filter"
                    validateTrigger="onBlur"
                  >
                    <VertInput
                      type="number"
                      placeholder={`Digite o ID ${filterTypeSelected === FILTER_TYPES.SEE_ALL_REDEEMS.value ? 'do pedido pai' : 'da solicitação'}`}
                      className="id-input"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="margin-top-small">
                <Col
                  lg={filterTypeSelected === FILTER_TYPES.SEE_CLIENTS_SOLICITATIONS.value ? 8 : 16}
                  md={filterTypeSelected === FILTER_TYPES.SEE_CLIENTS_SOLICITATIONS.value ? 8 : 16}
                  sm={24}
                  xs={24}
                >
                  <Form.Item
                    noStyle
                    name="status-filter"
                    validateTrigger="onBlur"
                  >
                    <VertSelect
                      items={statusOptions(filterTypeSelected)}
                      placeholder="Selecione o status para visualizar"
                    />
                  </Form.Item>
                </Col>
                {filterTypeSelected === FILTER_TYPES.SEE_CLIENTS_SOLICITATIONS.value && (
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <Form.Item
                      noStyle
                      name="type-filter"
                      validateTrigger="onBlur"
                    >
                      <VertSelect
                        items={[
                          OPTIONS_REDEMPTIONS.SEE_ALL_TYPES,
                          OPTIONS_REDEMPTIONS.SPOT,
                          OPTIONS_REDEMPTIONS.SPOT_HIERARCHY,
                          OPTIONS_REDEMPTIONS.HIERARCHY,
                        ]}
                        placeholder="Selecione o tipo para visualizar"
                      // prefix={isLoadingAddress && <VertIcon component={LoadingOutlined} />}
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col lg={8} md={8} sm={24} xs={24}>
                  <VertButton loading={isLoadingWallet} className="col-12" type="highlight" onClick={() => submitFilters()}>
                    FILTRAR
                  </VertButton>
                </Col>
              </Row>
            </Form>
          </VertContainer>

          <VertContainer className="margin-top-regular" fluid>
            <VertIcon component={LuFileSpreadsheet} color="highlight" />
            <Typography.Text className="txt-big color-highlight margin-left-extra-small">
              {filterTypeSelected === FILTER_TYPES.SEE_ALL_REDEEMS.value ? 'Resgates' : 'Solicitações'}
            </Typography.Text>
            <VertIcon onClick={() => { }} className="margin-left-extra-small" color="default" component={LuDownload} />
          </VertContainer>
          <VertContainer className="margin-top-small margin-bottom-regular">
            <ReportTable
              editRedeem={(info) => {
                setOrderSelected(info);
                setOpenedModal(true);
              }}
              filterType={filterTypeSelected}
              submitFunction={submitFilters}
            />
          </VertContainer>
        </div>

      </VertContainer>
      <VertModal width="90%" open={openedModal} onCancel={() => setOpenedModal(false)}>
        <OrderDetailsModal redemptionId={orderSelected?.orderId} />
      </VertModal>
    </>
  );
};

export default RedemptionsReportPage;
